import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { checkDoesObjectHaveContent, deepCopy, fetchTimeout, BaseURL, getCookie } from "../components/Common";
import { API_BASE } from "../AppConfig";
import BSL_Select from "../components/BSL_Select";
import ManageBusiness from "../components_main/ManageBusiness/ManageBusiness";
import { updateBusiness, loadUser } from "../redux_store/appState";
import { checkJobStateValidationSchema } from "../redux_store/jobState";

import * as BSL_Common from "../components/BSL_CommonControls";
import { Dialog, LinearProgress } from "@material-ui/core";
import BSL_Button from "../components/BSL_Button";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import BSL_TextInput from "../components/BSL_TextInput";
import Message from "../components/Message";
import BSL_Dialog from "../components/BSL_Dialog";

const useStyles = makeStyles({
    root: {
        height: "90%",
        overflow: "auto",
    },
});

export default function ManageUsers(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [intialise, setIntialise] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [exporting, setExporting] = React.useState(false);
    const [currentBusinessId, setCurrentBusinessId] = React.useState("");
    const [showDeleteBusiness, setShowDeleteBusiness] = React.useState(false);
    const [showArchiveBusiness, setShowArchiveBusiness] = React.useState(false);
    const [currentBusiness, setCurrentBusiness] = React.useState(null);
    const [currentBusinessUsers, setCurrentBusinessUsers] = React.useState(null);
    const [currentUserId, setCurrentUserId] = React.useState(null);
    const [currentUser, setCurrentUser] = React.useState(null);
    const [businessList, setBusinessList] = React.useState([]);
    const [allbusinessList, setAllBusinessList] = React.useState([]);
    const [errorStateBusiness, setErrorStateBusiness] = React.useState({});
    const [errorStateUser, setErrorStateUser] = React.useState({});
    const [showMessage, setShowMessage] = React.useState(false);
    const [showCodeGenerator, setShowCodeGenerator] = React.useState(false);
    const [businessName, setBusinessName] = React.useState("");
    const [codeSuggestion, setCodeSuggestion] = React.useState("---");
    const [saveButtonDisabled, setSaveButtonDisabled] = React.useState(false);

    const validationSchema = useSelector((state) => state.config.validationSchema);
    const user = useSelector((state) => state.app.user);

    let isAdmin = true;

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "business?isAdmin=" + isAdmin;
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    setAllBusinessList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    setAllBusinessList([]);
                });
        }
    }, [intialise]);

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "business/";
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    setBusinessList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    setBusinessList([]);
                });
        }
    }, [intialise]);

    React.useEffect(() => {
        if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache"))
            return;
        if (currentBusinessId) {
            let api_url = API_BASE() + "business/" + currentBusinessId;
            setLoading(true);
            setCurrentBusiness(null);
            setCurrentBusinessUsers(null);
            setCurrentUserId(null);
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    setCurrentBusiness(json);

                    //get users
                    api_url = API_BASE() + "users/" + currentBusinessId;
                    fetchTimeout(api_url, {
                        method: "GET",
                    })
                        .then((response) => response.json())
                        .then((json) => {
                            setCurrentBusinessUsers(json);
                            setLoading(false);
                        })
                        .catch((e) => {});
                })
                .catch((e) => {
                    setLoading(false);
                });
        } else {
            setCurrentBusiness(null);
        }
    }, [currentBusinessId]);

    const archiveBusiness = () => {
        let archivedBusiness = deepCopy(currentBusiness);
        if (archivedBusiness.Status === "ARCHIVED") archivedBusiness.Status = "ACTIVE";
        else archivedBusiness.Status = "ARCHIVED";
        setCurrentBusiness(archivedBusiness);
        saveBusinessData(archivedBusiness);
        setShowArchiveBusiness(false);
    };

    const deleteBusiness = () => {
        let api_url = API_BASE() + "business/" + currentBusinessId;
        setLoading(true);
        fetchTimeout(api_url, {
            method: "DELETE",
        })
            .then((response) => response.json())
            .then((json) => {
                setLoading(false);
                setIntialise(false);
            })
            .catch((e) => {
                setLoading(false);
                setIntialise(false);
            });
        setCurrentBusiness(null);
        setShowDeleteBusiness(false);
    };

    const saveBusiness = () => {
        saveBusinessData(currentBusiness);
    };

    const saveBusinessData = (businessData = null, business_id = null) => {
        var useBusinessId = currentBusinessId;
        if (business_id) useBusinessId = business_id;
        if (useBusinessId) {
            let errors_has_content = checkDoesObjectHaveContent(errorStateBusiness);

            if (errors_has_content) {
                setShowMessage({
                    type: "error",
                    message: "Error: Business " + errors_has_content.key + " " + errors_has_content.value,
                });
                return;
            }

            if (businessData === null) businessData = deepCopy(currentBusiness);

            let api_url = API_BASE() + "business/" + useBusinessId;
            setLoading(true);
            fetchTimeout(api_url, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(businessData),
            })
                .then((response) => response.json())
                .then((json) => {
                    setLoading(false);
                    setCurrentBusinessId(businessData.id);
                    setIntialise(false);
                    if (useBusinessId === user.BusinessDetails.id) {
                        dispatch(updateBusiness(businessData));
                    }
                    setShowMessage({
                        type: "Success",
                        message: "Success updating business details",
                    });
                })
                .catch((e) => {
                    setShowMessage({
                        type: "error",
                        message: "Error saving business details",
                    });
                    setLoading(false);
                });
        }
    };

    const actUser = (email) => {
        let cds_token = getCookie("CDS_token");
        let SF_user = email;

        if (cds_token && SF_user) {
            dispatch(loadUser(SF_user, "cent2021")).then((result) => {
                if (!result) {
                    setTimeout(function () {
                        dispatch(loadUser(SF_user, "cent2021")).then((result) => {
                            if (!result) {
                                alert("Error loading user 2");
                            } else if (result.Error) {
                                alert("Error loading user 3");
                            }
                        });
                    }, 2000);
                } else if (result.Error) {
                    alert("Error loading user");
                }
            });
        }
    };

    const deleteUser = () => {};
    const saveUser = () => {
        if (currentUserId && currentUser) {
            let errors_has_content = checkDoesObjectHaveContent(errorStateUser);

            if (errors_has_content) {
                setShowMessage({
                    type: "error",
                    message: "Error: User " + errors_has_content.key + " " + errors_has_content.value,
                });
                return;
            }

            let api_url = API_BASE() + "user/" + btoa(currentUser.id);
            setLoading(true);
            fetchTimeout(api_url, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(currentUser),
            })
                .then((response) => response.json())
                .then((json) => {
                    //get users
                    api_url = API_BASE() + "users/" + currentBusinessId;
                    fetchTimeout(api_url, {
                        method: "GET",
                    })
                        .then((response) => response.json())
                        .then((json) => {
                            setCurrentBusinessUsers(json);
                            setLoading(false);
                        })
                        .catch((e) => {
                            setCurrentBusinessUsers(null);
                            setLoading(false);
                        });
                })
                .catch((e) => {
                    setLoading(false);
                });
        }
    };

    const updateNewUser = (param) => (e, value) => {
        let val = value ? value : e;
        if (val?.target?.value) val = e?.target?.value;

        if (param == "UserCode") {
            val = val.replace(/[^\w\s]/gi, "");
            if (val.length > 2) {
                val = val.substring(0, 2);
            }
            if (val.length < 2) {
                val += "1";
            }
        }

        let updateUser = deepCopy(currentUser);
        updateUser[param] = val;
        setCurrentUser(updateUser);

        // validate using customer validation schema
        if (validationSchema?.Customer?.[param]) {
            let error = "";
            error = checkJobStateValidationSchema(validationSchema, "Customer", null, param, val);
            let newErrorState = deepCopy(errorStateUser);
            newErrorState[param] = error;
            setErrorStateUser(newErrorState);
        }
    };

    const updateSuggestion = (name) => {
        setBusinessName(name);

        const alphaName = name.toUpperCase().replace(/[^A-Z\s]/g, "");
        const cleaned = alphaName.replace(/\s+/g, "");
        const words = alphaName.trim().split(/\s+/).filter(Boolean);

        const toThreeLetters = (str) => str.slice(0, 3).padEnd(3, "X");
        const isTaken = (code) => allbusinessList.some((item) => item.id === code);

        const genCodeFromWords = () => {
            const code = words.map((w) => w[0] || "").join("");
            return toThreeLetters(code);
        };

        const genCodeFirstThree = () => {
            return toThreeLetters(cleaned);
        };

        const genCodeMixed = () => {
            if (cleaned.length >= 3) {
                return toThreeLetters(cleaned[0] + cleaned[1] + cleaned[cleaned.length - 1]);
            }
            return toThreeLetters(cleaned);
        };

        const genCodeLastThree = () => {
            const lastThree = cleaned.slice(-3);
            return toThreeLetters(lastThree);
        };

        const genCodeFirstMiddleLast = () => {
            if (cleaned.length >= 3) {
                const midIndex = Math.floor(cleaned.length / 2);
                return toThreeLetters(cleaned[0] + cleaned[midIndex] + cleaned[cleaned.length - 1]);
            }
            return toThreeLetters(cleaned);
        };

        const generators = [
            genCodeFromWords,
            genCodeFirstThree,
            genCodeMixed,
            genCodeLastThree,
            genCodeFirstMiddleLast,
        ];

        function findAvailableCode(index = 0) {
            if (index >= generators.length) {
                return "---";
            }

            const candidate = generators[index]();
            if (!isTaken(candidate)) {
                return candidate;
            }

            return findAvailableCode(index + 1);
        }

        const finalCode = findAvailableCode();
        setCodeSuggestion(finalCode);
    };

    const exportUsers = () => {
        setExporting(true);
        const apiUrl = API_BASE() + "users/all";

        fetchTimeout(apiUrl, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                const csvData = jsonToCSV(json);
                const currentDate = new Date();
                const dateString = currentDate.toISOString().split("T")[0];
                const filename = `user_data_${dateString}.csv`;
                setExporting(false);
                downloadCSV(csvData, filename);
            })
            .catch((e) => {
                setExporting(false);
                console.error("User export error", e);
            });
    };

    function jsonToCSV(jsonData, headers) {
        // Use keys from the first object as headers if headers aren't provided
        if (!headers && jsonData.length > 0) {
            headers = Object.keys(jsonData[0]);
        }

        // Map the headers to a CSV string
        const csvRows = [
            headers.join(","), // Join headers to create the first row
            ...jsonData.map((row) => headers.map((fieldName) => JSON.stringify(row[fieldName] || "")).join(",")), // Map each json object to a CSV row
        ];

        return csvRows.join("\n");
    }

    function downloadCSV(csvData, filename = "export.csv") {
        const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    }

    React.useEffect(() => {
        if (currentUserId) {
            let api_url = API_BASE() + "user/" + btoa(currentUserId) + "/cent2021";
            setLoading(true);
            setCurrentUser(null);
            setErrorStateUser({});

            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    setCurrentUser(json);
                    setLoading(false);
                })
                .catch((e) => {
                    setLoading(false);
                });
        } else {
            setCurrentUser(null);
            setErrorStateUser({});
        }
    }, [currentUserId]);

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "business?isAdmin=" + isAdmin;
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    setAllBusinessList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    setAllBusinessList([]);
                });
        }
    }, [intialise]);

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "business/";
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    setBusinessList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    setBusinessList([]);
                });
        }
    }, [intialise]);

    let roleTypes = [
        { Key: 10, Display: "Dealer Admin" },
        { Key: 0, Display: "Dealer Standard" },
    ];

    if (currentBusiness) {
        if (user.Role >= 90 && currentBusiness.Type === "BBC") roleTypes.unshift({ Key: 90, Display: "BBC Standard" });
        if (user.Role >= 98 && currentBusiness.Type === "BBC")
            roleTypes.unshift({ Key: 91, Display: "BBC State Admin" });
        if (user.Role >= 99 && (currentBusiness.Type === "Engineer" || currentBusiness.Type === "BBC"))
            roleTypes.unshift({ Key: 99, Display: "BBC Super" });
        if (currentBusiness.Type === "Engineer") roleTypes = [{ Key: 92, Display: "Engineer" }];
    }

    let businessesSorted = [];
    businessesSorted.push({ disabled: true, Key: "[BBC]", Display: "[BBC Licenses]" });
    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && item.Type === "BBC")
            businessesSorted.push({ Key: item.id, Display: item.id + "-" + item.Name });
    }

    businessesSorted.push({ disabled: true, Key: "[Engineers]", Display: "[Engineers Licenses]" });
    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && item.Type === "Engineer")
            businessesSorted.push({ Key: item.id, Display: item.id + "-" + item.Name });
    }

    businessesSorted.push({ disabled: true, Key: "[Customers]", Display: "[Customers Licenses]" });
    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && (!item.Type || (item.Type !== "Engineer" && item.Type !== "BBC")))
            businessesSorted.push({ Key: item.id, Display: item.id + "-" + item.Name });
    }

    businessesSorted.push({ disabled: true, Key: "[Archived]", Display: "[Archived Licenses]" });
    for (var item of businessList) {
        if (item.Status === "ARCHIVED")
            businessesSorted.push({
                Key: item.id,
                Display: (
                    <span style={{ color: "red" }}>
                        <em>{item.id + "-" + item.Name}</em>
                    </span>
                ),
            });
    }

    const [bulkBusinessOpen, setBulkBusinessOpen] = React.useState(false);
    const [bulkLoading, setBulkLoading] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [error, setError] = React.useState("");
    const [businessUpdates, setBusinessUpdates] = React.useState([]); // Stores extracted data

    const handleSave = async () => {
        if (!businessUpdates.length) {
            setError("No valid business updates found.");
            return;
        }

        setBulkLoading(true);

        try {
            const failedUpdates = [];

            // Fetch all businesses in parallel
            const businessPromises = businessUpdates.map(({ Bus_id }) =>
                fetchTimeout(API_BASE() + "business/" + Bus_id, { method: "GET" })
                    .then((response) => response.json())
                    .catch((error) => {
                        console.error(`❌ Error fetching business ${Bus_id}:`, error);
                        return null;
                    })
            );

            const businessDataList = await Promise.all(businessPromises);

            // Process updates
            const updatePromises = businessUpdates.map(async ({ Bus_id, NewDeliveryFee }, index) => {
                const business = businessDataList[index];

                if (
                    !business ||
                    (Array.isArray(business) && business.length === 0) ||
                    (typeof business === "object" && Object.keys(business).length === 0)
                ) {
                    console.warn(`⚠️ No valid data found for Business ID ${Bus_id}, skipping update.`);
                    failedUpdates.push(Bus_id);
                    return;
                }

                // Clone and update business data
                const updatedBusiness = { ...business, DeliveryFee: NewDeliveryFee };

                try {
                    await saveBusinessData(updatedBusiness, Bus_id);
                } catch (error) {
                    failedUpdates.push(Bus_id);
                }
            });

            await Promise.all(updatePromises);

            if (failedUpdates.length > 0) {
                setShowMessage({
                    type: "error",
                    message: `Failed to update the following Business IDs: ${failedUpdates.join(", ")}`,
                });
                console.warn(`❌ Some updates failed:`, failedUpdates);
            } else {
                setShowMessage({
                    type: "success",
                    message: "Successfully updated all businesses.",
                });
            }

            // Reset state
            setBulkBusinessOpen(false);
            setSelectedFile(null);
            setBusinessUpdates([]);
            setError("");
        } catch (err) {
            setShowMessage({
                type: "error",
                message: "Error occurred while updating businesses.",
            });
        } finally {
            setBulkLoading(false);
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (!file) return;

        if (file.type !== "text/csv") {
            setError("Please upload a valid CSV file.");
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const text = e.target.result;
            const rows = text.split("\n").map((row) => row.trim());
            const headers = rows[0]?.split(",").map((cell) => cell.trim());

            if (headers[0] !== "Bus_id" || headers[1] !== "New Delivery Fee") {
                setError(
                    "Invalid file format. Ensure Cell A1 contains 'Bus_id' and Cell B1 contains 'New Delivery Fee'."
                );
                return;
            }

            const updates = [];
            for (let i = 1; i < rows.length; i++) {
                const cols = rows[i].split(",").map((cell) => cell.trim());

                if (cols.length >= 2) {
                    const Bus_id = cols[0];
                    const NewDeliveryFee = parseFloat(cols[1]);

                    if (!isNaN(NewDeliveryFee) && Bus_id) {
                        updates.push({ Bus_id, NewDeliveryFee });
                    }
                }
            }

            if (updates.length === 0) {
                setError("No valid data found in the file.");
            } else {
                setSelectedFile(file);
                setBusinessUpdates(updates);
                setError(""); // Clear error if validation passes
            }
        };

        reader.readAsText(file);
    };

    return (
        <div className={classes.root}>
            <Dialog style={{ padding: "10px" }} open={bulkBusinessOpen} onClose={() => setBulkBusinessOpen(false)}>
                <p>Upload a CSV file with Business ID in Column A and Delivery Fee in Column B.</p>
                <p>
                    <a href={BaseURL("data/template.csv")} download>
                        Download CSV template
                    </a>
                </p>
                <input type="file" accept=".csv" onChange={handleFileChange} />
                {error && <p style={{ color: "red" }}>{error}</p>}
                {selectedFile && !error && <p>Selected File: {selectedFile.name}</p>}
                <BSL_Button onClick={handleSave} disabled={bulkLoading || !!error || !businessUpdates.length}>
                    {bulkLoading ? "LOADING ..." : "SAVE"}
                </BSL_Button>
            </Dialog>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionRow style={{ borderBottom: "1px solid grey" }}>
                    <BSL_Select
                        label={"Business License"}
                        style={{ flex: 2, maxWidth: "600px" }}
                        value={currentBusinessId}
                        tight={true}
                        items={businessesSorted}
                        onChange={(e) => {
                            setCurrentBusinessId(e.target.value);
                        }}
                    />

                    <BSL_Button
                        label="Suggest New Account Code"
                        onClick={() => setShowCodeGenerator(true)}
                        style={{
                            maxWidth: "300px",
                            maxHeight: "32px",
                            alignSelf: "end",
                            marginLeft: "72px",
                            marginBottom: "7px",
                        }}
                    />

                    <BSL_Button
                        label="Export User Data"
                        disabled={exporting}
                        onClick={exportUsers}
                        style={{
                            maxWidth: "300px",
                            maxHeight: "32px",
                            alignSelf: "end",
                            marginLeft: "72px",
                            marginBottom: "7px",
                        }}
                    />

                    <BSL_Button
                        label="Bulk Update Business Pricing"
                        disabled={exporting}
                        onClick={() => setBulkBusinessOpen(true)}
                        style={{
                            maxWidth: "300px",
                            maxHeight: "32px",
                            alignSelf: "end",
                            marginLeft: "72px",
                            marginBottom: "7px",
                        }}
                    />

                    <div style={{ flex: 1 }} />
                </BSL_Common.SectionRow>
                {loading && <LinearProgress />}
                {currentBusiness && (
                    <div
                        style={{
                            display: "flex",
                            overflow: "auto",
                            textAlign: "left",
                            paddingRight: "10px",
                            flexDirection: "column",
                        }}
                    >
                        <BSL_Common.SectionRow
                            style={{
                                width: "98%",
                            }}
                        >
                            <BSL_Common.SectionContainer
                                style={{
                                    paddingRight: "10px",
                                    flex: 1,
                                }}
                            >
                                <ManageBusiness
                                    BusinessDetails={currentBusiness}
                                    UpdateBusiness={setCurrentBusiness}
                                    ErrorState={errorStateBusiness}
                                    SetErrorState={setErrorStateBusiness}
                                    admin={true}
                                    setSaveButtonDisabled={setSaveButtonDisabled}
                                    user={user}
                                />
                                <BSL_Common.SectionRow>
                                    {currentBusiness?.Status !== "ARCHIVED" && (
                                        <BSL_Button
                                            label="Save Business Detail Changes"
                                            onClick={saveBusiness}
                                            style={{ margin: "10px" }}
                                            disabled={saveButtonDisabled}
                                        />
                                    )}
                                    <BSL_Button
                                        secondary={currentBusiness?.Status !== "ARCHIVED"}
                                        label={
                                            currentBusiness?.Status === "ARCHIVED"
                                                ? "Unarchive Business"
                                                : "Archive Business"
                                        }
                                        onClick={() => setShowArchiveBusiness(true)}
                                        style={{ margin: "10px" }}
                                    />
                                </BSL_Common.SectionRow>

                                {loading && <LinearProgress />}
                            </BSL_Common.SectionContainer>

                            <BSL_Common.SectionContainer
                                style={{
                                    flex: 1,
                                    paddingLeft: "10px",
                                    background: "#f2f2f2",
                                    borderLeft: "1px solid grey",
                                }}
                            >
                                <BSL_Common.SectionHeader>Manage Users</BSL_Common.SectionHeader>
                                <BSL_Common.SectionRow>
                                    <BSL_Select
                                        id={"userDropDown"}
                                        tight={true}
                                        value={currentUserId}
                                        onChange={(event) => {
                                            setCurrentUserId(event.target.value);
                                        }}
                                        items={
                                            currentBusinessUsers
                                                ? currentBusinessUsers.map((user) => {
                                                      return {
                                                          Key: user.id,
                                                          Display:
                                                              user.FirstName +
                                                              (user.LastName ? " " + user.LastName : ""),
                                                      };
                                                  })
                                                : []
                                        }
                                    ></BSL_Select>
                                </BSL_Common.SectionRow>

                                {currentUserId && currentUser && (
                                    <BSL_Common.SectionContainer
                                        style={{
                                            padding: "10px",
                                            flex: 1,
                                        }}
                                    >
                                        Editing Details for{" "}
                                        {currentUser.FirstName +
                                            (currentUser.LastName ? " " + currentUser.LastName : "")}
                                        <BSL_Common.SectionContainer>
                                            <BSL_Common.SectionHeader>User Settings</BSL_Common.SectionHeader>

                                            <BSL_Common.SectionRow>
                                                <SegmentedButtonGroup
                                                    tight
                                                    label="Status"
                                                    ButtonGroupStyle={{
                                                        flexWrap: "wrap",
                                                    }}
                                                    style={{ flex: "none" }}
                                                    value={currentUser?.Status}
                                                    items={
                                                        currentUser?.Status === "ARCHIVED"
                                                            ? ["ARCHIVED"]
                                                            : ["ACTIVE", "DEACTIVATED"]
                                                    }
                                                    onChange={updateNewUser("Status")}
                                                />
                                            </BSL_Common.SectionRow>
                                            <BSL_Common.SectionRow>
                                                <BSL_TextInput
                                                    label="Display Name"
                                                    preValidate="name"
                                                    tight
                                                    disabled
                                                    value={currentUser.DisplayName}
                                                    onBlur={updateNewUser("DisplayName")}
                                                    error={errorStateUser?.DisplayName}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                                <BSL_TextInput
                                                    label="First Name"
                                                    preValidate="name"
                                                    tight
                                                    disabled
                                                    value={currentUser.FirstName}
                                                    onBlur={updateNewUser("FirstName")}
                                                    error={errorStateUser?.FirstName}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                                <BSL_TextInput
                                                    label="Last Name"
                                                    preValidate="name"
                                                    tight
                                                    disabled
                                                    value={currentUser.LastName}
                                                    onBlur={updateNewUser("LastName")}
                                                    error={errorStateUser?.LastName}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                                <BSL_TextInput
                                                    label="User Code"
                                                    tight
                                                    value={currentUser.UserCode}
                                                    onBlur={updateNewUser("UserCode")}
                                                    error={errorStateUser?.UserCode}
                                                />
                                            </BSL_Common.SectionRow>
                                            <BSL_Common.SectionRow>
                                                <BSL_TextInput
                                                    label="Username"
                                                    tight
                                                    disabled
                                                    value={currentUser.id}
                                                    helperText={"*sync with Salesforce"}
                                                    textFieldStyle={{ width: "47%" }}
                                                />
                                            </BSL_Common.SectionRow>
                                            <BSL_Common.SectionRow>
                                                <BSL_TextInput
                                                    label="Email"
                                                    tight
                                                    disabled
                                                    value={currentUser.Email}
                                                    onBlur={updateNewUser("Email")}
                                                    error={errorStateUser?.Email}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                                <BSL_TextInput
                                                    label="Phone"
                                                    tight
                                                    disabled
                                                    value={currentUser.Phone}
                                                    onBlur={updateNewUser("Phone")}
                                                    error={errorStateUser?.Phone}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                            </BSL_Common.SectionRow>

                                            {currentUser.Role <= user.Role && (
                                                <SegmentedButtonGroup
                                                    label="User Type"
                                                    ButtonGroupStyle={{
                                                        flexWrap: "wrap",
                                                    }}
                                                    style={{ flex: "none" }}
                                                    value={currentUser.Role}
                                                    disabled
                                                    items={roleTypes}
                                                    onChange={(e, val) => {
                                                        let updateUser = deepCopy(currentUser);
                                                        updateUser["Role"] = val;
                                                        updateUser["RoleName"] = "";
                                                        for (let role of roleTypes) {
                                                            if (role.Key === val) updateUser["RoleName"] = role.Display;
                                                        }
                                                        setCurrentUser(updateUser);
                                                    }}
                                                    helperText={"*sync with Salesforce"}
                                                />
                                            )}

                                            <BSL_Common.SectionRow>
                                                <SegmentedButtonGroup
                                                    tight
                                                    label="Beta User"
                                                    ButtonGroupStyle={{ flexWrap: "wrap" }}
                                                    style={{ flex: "none" }}
                                                    value={currentUser?.BetaUser}
                                                    items={["true", "false"]}
                                                    onChange={updateNewUser("BetaUser")}
                                                />
                                            </BSL_Common.SectionRow>
                                            <BSL_Common.SectionRow>
                                                <BSL_TextInput
                                                    label="API KEY"
                                                    tight
                                                    disabled
                                                    value={currentUser?.apiKey}
                                                    onBlur={updateNewUser("apiKey")}
                                                    error={errorStateUser?.apiKey}
                                                />
                                            </BSL_Common.SectionRow>
                                            <BSL_Common.SectionRow
                                                style={{
                                                    padding: "20px",
                                                }}
                                            >
                                                <BSL_Button label="Save User Changes" onClick={saveUser} />
                                                <BSL_Button secondary label="Delete User" onClick={deleteUser} />
                                                {user.Role >= 99 && (
                                                    <BSL_Button
                                                        secondary
                                                        label="Act as User"
                                                        onClick={() => {
                                                            actUser(currentUser.Email);
                                                        }}
                                                    />
                                                )}
                                            </BSL_Common.SectionRow>
                                        </BSL_Common.SectionContainer>
                                    </BSL_Common.SectionContainer>
                                )}
                            </BSL_Common.SectionContainer>
                        </BSL_Common.SectionRow>
                    </div>
                )}
            </BSL_Common.SectionContainer>
            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />

            {showCodeGenerator && (
                <BSL_Dialog
                    title={"Suggest New Account Code"}
                    open={showCodeGenerator}
                    onClose={() => setShowCodeGenerator(false)}
                    button1Text={"DONE"}
                    button1Click={() => setShowCodeGenerator(false)}
                >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <BSL_TextInput
                            label="Enter Business Name"
                            tight
                            value={businessName}
                            onBlur={(value) => updateSuggestion(value)}
                            onChange={(value) => updateSuggestion(value)}
                        />
                        <div
                            style={{
                                textAlign: "center",
                            }}
                        >
                            SUGGESTED CODE:
                            <br />
                            <div
                                style={{
                                    padding: "0px",
                                    border: "1px dotted #444444",
                                    borderRadius: "10px",
                                    fontSize: "38px",
                                    width: "50%",
                                    marginLeft: "25%",
                                }}
                            >
                                {codeSuggestion}
                            </div>
                        </div>
                    </div>
                </BSL_Dialog>
            )}

            {currentBusiness && showArchiveBusiness && (
                <BSL_Dialog
                    title={currentBusiness?.Status === "ARCHIVED" ? "Unarchive Business?" : "Archive Business?"}
                    open={showArchiveBusiness}
                    onClose={() => setShowArchiveBusiness(false)}
                    button1Text={currentBusiness?.Status === "ARCHIVED" ? "ACTIVE" : "ARCHIVED"}
                    button1Click={() => archiveBusiness(currentBusinessId)}
                    button2Text="No"
                    button2Click={() => setShowArchiveBusiness(false)}
                >
                    <div style={{ display: "flex" }}>
                        <div>
                            Are you sure you would like to{" "}
                            {currentBusiness?.Status === "ARCHIVED" ? "SET ACTIVE" : "ARCHIVE"} this Business (
                            {currentBusiness.Name})?
                        </div>
                    </div>
                </BSL_Dialog>
            )}

            {currentBusiness && showDeleteBusiness && (
                <BSL_Dialog
                    title="Delete Business"
                    open={showDeleteBusiness}
                    onClose={() => setShowDeleteBusiness(false)}
                    button1Text="IRREVERSIBLY DELETE"
                    button1Click={() => deleteBusiness(currentBusinessId)}
                    button2Text="No"
                    button2Click={() => setShowDeleteBusiness(false)}
                >
                    <div style={{ display: "flex" }}>
                        <div>
                            Are you sure you would like to IRREVERSIBLY DELETE this Business ({currentBusiness.Name})?
                        </div>
                    </div>
                </BSL_Dialog>
            )}
        </div>
    );
}
